package com.wintermar.inspection.core.ui.component.image.util

enum class FileGroupTypes(val extensions: List<String>) {
    IMAGES(listOf(".jpg", ".jpeg", ".png")),
    DOCUMENTS(listOf(".pdf", ".doc", ".docx", ".xls", ".xlsx")),
    IMAGES_AND_DOCUMENTS(listOf(".jpg", ".jpeg", ".png", ".pdf", ".doc", ".docx", ".xls", ".xlsx"));


    fun getExtensionsWithoutDot(): List<String> {
        return this.extensions.map { it.removePrefix(".") }
    }
}
